const clickAnchor = (href: string): void => {
  const a = document.createElement('a')
  a.href = href
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

const isStandaloneDisplay = (): boolean => {
  if (typeof window === 'undefined') return false
  const nav = window.navigator as Navigator & { standalone?: boolean }
  if (nav.standalone === true) return true
  return window.matchMedia?.('(display-mode: standalone)').matches === true
}

/**
 * No PWA Android instalado, `<a target="_blank">` e `window.open` navegam dentro do app
 * e substituem a tela. O intent abre o navegador padrão e deixa o Synap aberto.
 */
const androidBrowserIntent = (url: string): string | null => {
  if (!isStandaloneDisplay()) return null
  if (!/android/i.test(window.navigator.userAgent ?? '')) return null
  const scheme = url.toLowerCase().startsWith('http://') ? 'http' : 'https'
  const stripped = url.replace(/^https?:\/\//i, '')
  return `intent://${stripped}#Intent;scheme=${scheme};action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(url)};end`
}

/**
 * Abre URL http(s) fora do fluxo SPA (nova aba / navegador padrão).
 * Em PWA standalone, `window.open` pode ser bloqueado; usa fallback com `<a target="_blank">`.
 */
export function openExternalUrl(url: string): void {
  const u = url.trim()
  if (!/^https?:\/\//i.test(u)) return
  const intent = androidBrowserIntent(u)
  if (intent) {
    clickAnchor(intent)
    return
  }
  const opened = window.open(u, '_blank', 'noopener,noreferrer')
  if (opened != null) return
  clickAnchor(u)
}
